var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "container my-auto" }, [
        _c("header", { staticClass: "my-4" }, [
          _c("img", {
            staticClass: "mx-auto d-block",
            attrs: { src: "/images/" + _vm.logo, alt: "Logo" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card card-denied mx-auto my-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.denyType == "application-denied"
                ? [
                    _c("h5", { staticClass: "card-title text-center" }, [
                      _vm._v("Geen toegang")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-primary my-3",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n              U heeft geen toegang tot " +
                            _vm._s(_vm.applicationName) +
                            "."
                        ),
                        _c("br")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ehr-button",
                      {
                        staticClass: "btn-block mt-4",
                        attrs: { "button-type-class": "btn-primary" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.logout($event)
                          }
                        }
                      },
                      [_vm._v("\n              Afmelden\n            ")]
                    )
                  ]
                : _vm.denyType == "module-denied"
                ? [
                    _c("h5", { staticClass: "card-title text-center" }, [
                      _vm._v("Geen toegang")
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "ehr-button",
                      {
                        staticClass: "btn-block mt-4",
                        attrs: { "button-type-class": "btn-primary" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.returnToHome($event)
                          }
                        }
                      },
                      [_vm._v("\n              Naar startpagina\n            ")]
                    )
                  ]
                : _vm.denyType == "not-found"
                ? [
                    _c("h5", { staticClass: "card-title text-center" }, [
                      _vm._v("Pagina niet gevonden")
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "ehr-button",
                      {
                        staticClass: "btn-block mt-4",
                        attrs: { "button-type-class": "btn-primary" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.returnToHome($event)
                          }
                        }
                      },
                      [_vm._v("\n              Naar startpagina\n            ")]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-primary my-3", attrs: { role: "alert" } },
      [
        _vm._v("\n              U heeft geen toegang tot deze module."),
        _c("br")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-primary my-3", attrs: { role: "alert" } },
      [_vm._v("\n              Deze pagina bestaat niet."), _c("br")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }